import React from "react";
import {
  Controller,
  type UseFormReturn,
  type FieldValues,
} from "react-hook-form";
import GenericField, {
  fieldTypeOptions,
  type ServerFieldOption,
} from "../GenericField/GenericField";
import { REQUIRED_ERROR_MESSAGE } from "@SeemplicityDev/shared";

import "./TicketProviders.scss";

type KeysObject = Record<string, unknown>;

export interface TicketProvidersProps {
  providersOptions?: ServerFieldOption[];
  onTicketProviderChange?: () => void;
  disabled?: boolean;
  keysObject: KeysObject;
  shouldUnregister?: boolean;
  viewMode?: boolean;
  formMethods?: UseFormReturn<FieldValues> | null;
  withMarginBottom?: boolean;
}

const TicketProviders: React.FC<TicketProvidersProps> = ({
  providersOptions,
  onTicketProviderChange = () => {},
  disabled = false,
  keysObject,
  shouldUnregister = false,
  viewMode = false,
  formMethods = null,
  withMarginBottom = true, // to support backwards-compatibility
}) => {
  return (
    <div
      className={`ticket-providers ${withMarginBottom ? "with-margin-bottom" : ""}`}
    >
      <Controller
        shouldUnregister={shouldUnregister}
        name={`ticketProvider`}
        render={({ field: { onChange, onBlur, value } }) => {
          return (
            <GenericField
              onChange={(val) => {
                onChange(val);
                const keysResetObject: KeysObject = {};
                Object.keys(keysObject)?.forEach((key) => {
                  keysResetObject[key] = null;
                });
                formMethods?.resetField("keys", {
                  defaultValue: keysResetObject,
                });
                formMethods?.resetField("fields", { defaultValue: {} });

                onTicketProviderChange();
              }}
              name={"ticketProvider"}
              onBlur={onBlur}
              clearable={false}
              viewMode={viewMode}
              value={value}
              error={
                formMethods?.formState?.errors?.ticketProvider
                  ? formMethods?.formState?.errors?.ticketProvider
                  : null
              }
              disabled={disabled}
              input={fieldTypeOptions.SELECT}
              label={"Instance"}
              options={providersOptions}
              placeholder={"Select Instance"}
              required
            />
          );
        }}
        control={formMethods?.control}
        rules={{ required: REQUIRED_ERROR_MESSAGE }}
      />
    </div>
  );
};

export default TicketProviders;
